import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/common/PageHeader";
import { CibilCheck } from "@/components/tools/CibilCheck";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CibilCheckPage() {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <div className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <Button variant="ghost" size="icon" onClick={() => navigate("/tools")}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <PageHeader title="CIBIL Check" subtitle="Check customer credit score" />
        </div>
        <CibilCheck />
      </div>
    </AppLayout>
  );
}
